<template>
  <Gestures/>
  <Captions/>

  <media-controls :style="mediaControlStyle"
                  class="absolute inset-0 z-10 flex h-full w-full flex-col rounded-lg bg-gradient-to-t from-black/10 to-transparent opacity-0 media-controls:opacity-100 transition-opacity"
  >

    <div class="pointer-events-none flex-1"/>

    <media-controls-group class="z-10 flex w-full items-center px-2 control-group" :class="isSmall && '-my-1'">
      <TimeSlider :thumbnails="thumbnails"/>
    </media-controls-group>

    <media-controls-group
      class="z-10 flex w-full items-center bg-gradient-to-b from-transparent to-black/75 px-2 pb-2 -mt-0.5 control-group">
      <PlayButton tooltip-placement="top start" :is-small="isSmall"/>
      <MuteButton tooltip-placement="top"/>
      <VolumeSlider v-if="!isSmall"/>
      <TimeGroup/>
      <ChapterTitle v-if="!isSmall"/>
      <div class="flex-1"/>
      <SeekButtons/>
      <CaptionButton v-if="!isSmall" tooltip-placement="top"/>
      <ChapterMenu v-if="!isSmall && hasChapters" placement="top end" tooltip-placement="top" :thumbnails="thumbnails"/>
      <SettingsMenu v-if="!isSmall" placement="top end" tooltip-placement="top"/>
      <PIPButton v-if="!isSmall" tooltip-placement="top"/>
      <FullscreenButton tooltip-placement="top end" :is-small="isSmall"/>
    </media-controls-group>

    <media-controls-group v-if="isSmall"
                          class="absolute top-0 right-0 left-0 z-10 ml-auto flex w-full items-center px-3 pt-2">
      <div class="flex-1"/>
      <CaptionButton tooltip-placement="bottom end"/>
      <ChapterMenu v-if="hasChapters" placement="bottom end" tooltip-placement="bottom end" :thumbnails="thumbnails"
                   is-small/>
      <SettingsMenu placement="bottom end" tooltip-placement="bottom end" is-small/>
      <MuteButton tooltip-placement="bottom end"/>
    </media-controls-group>

    <div
      class="absolute inset-0 z-0 flex justify-center" :class="isSmall ? 'items-center pb-4' : 'items-start pt-14'">
      <div @click="emits('play')" :class="isSmall ? 'h-2/6' : 'h-[calc(100%-4rem)]'"
           class="media-paused:flex hidden w-full items-center justify-center">
        <div class="rounded-full bg-black bg-opacity-50 p-3">
          <svg class="media-paused:block hidden h-8 w-8 md:h-10 md:w-10" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.6667 6.6548C10.6667 6.10764 11.2894 5.79346 11.7295 6.11862L24.377 15.4634C24.7377 15.7298 24.7377 16.2692 24.3771 16.5357L11.7295 25.8813C11.2895 26.2065 10.6667 25.8923 10.6667 25.3451L10.6667 6.6548Z" fill="currentColor"/>
          </svg>

        </div>
      </div>

      <div @click="emits('pause')" :class="isSmall ? 'h-2/6' : 'h-[calc(100%-4rem)]'"
           class="block media-paused:hidden w-full items-center justify-center"/>
    </div>

  </media-controls>
</template>

<script setup>
import CaptionButton from "./VideoPlayerCaptionButton.vue";
import ChapterMenu from "./VideoPlayerChapterMenu.vue";
import FullscreenButton from "./VideoPlayerFullscreenButton.vue";
import MuteButton from "./VideoPlayerMuteButton.vue";
import PIPButton from "./VideoPlayerPIPButton.vue";
import PlayButton from "./VideoPlayerPlayButton.vue";
import Captions from "./VideoPlayerCaptions.vue";
import ChapterTitle from "./VideoPlayerChapterTitle.vue";
import Gestures from "./VideoPlayerGestures.vue";
import SeekButtons from "./VideoPlayerSeekButtons.vue";
import SettingsMenu from "./VideoPlayerSettingsMenu.vue";
import TimeSlider from "./VideoPlayerTimeSlider.vue";
import TimeGroup from "./VideoPlayerTimeGroup.vue";
import VolumeSlider from "./VideoPlayerVolumeSlider.vue";
import {computed} from "vue";

const emits = defineEmits(["play", "pause"]);
const props = defineProps({
  thumbnails: {
    type: String,
    required: false,
  },
  hasChapters: {
    type: Boolean,
    default: false,
  },
  isSmall: {
    type: Boolean,
    default: false,
  },
});

const mediaControlStyle = computed(() => {
  if (props.isSmall) return "--media-tooltip-y-offset:4px;--media-menu-y-offset:4px;--media-slider-preview-offset:4px;";
  return "--media-tooltip-y-offset:30px;--media-menu-y-offset:30px;--media-slider-preview-offset:30px;";
});
</script>

<style>
@media (min-width: 640px) {
  .control-group {
    opacity: 0;
  }

  media-player[data-paused] .control-group {
    opacity: 1;
  }

  .video-player-container:hover .control-group {
    opacity: 1;
  }
}
</style>
